const styles = `:host {
  border-collapse: collapse;
  display: table;
}`; export default styles;